import { supporterBillingDetailsQuery, supporterPlansQuery } from "@/api/supporter";
import { useSupporterId } from "@/utils/roles";
import { Command, List, ListItem } from "@givenwell/command-palette";
import { BackwardsIcon, DollarCoinIcon } from "@givenwell/core-solid-icons";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const mockPlanCommand: Command = {
  id: "mock-plan",
  title: "Mock Supporter Plan",
  icon: <DollarCoinIcon width="21" />,
  Component: () => {
    const queryClient = useQueryClient();
    const supporterId = useSupporterId()!;
    const idk = useQuery({ ...supporterPlansQuery(supporterId), enabled: !!supporterId });
    return (
      <List
        navigationTitle="Change Supporter Plan"
        searchBarPlaceholder="Select a plan..."
        content={[
          ...(idk.data?.plans.map(p => {
            return {
              title: p.name,
              actions: [
                {
                  title: "Switch Plan",
                  onAction: ({ close }) => {
                    queryClient.setQueryData(supporterBillingDetailsQuery(supporterId).queryKey, prev => {
                      if (!prev) return prev;
                      return {
                        ...prev,
                        plan_id: p.plan_id,
                      };
                    });
                    close();
                  },
                },
              ],
            } as ListItem;
          }) || []),
          {
            icon: <BackwardsIcon />,
            title: "Back to default",
            actions: [
              {
                title: "Back to default",
                onAction: ({ close }) => {
                  queryClient.invalidateQueries(supporterBillingDetailsQuery(supporterId));
                  close();
                },
              },
            ],
          },
        ]}
      />
    );
  },
};
